import { render } from "./PledgeSlideToSubmit.vue?vue&type=template&id=d8cd4d6a"
import script from "./PledgeSlideToSubmit.vue?vue&type=script&lang=js"
export * from "./PledgeSlideToSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__